// extracted by css-extract-rspack-plugin
export default {"card":"card--MPGC0pEIcQ0Yfjgn","cardContent":"card-content--eB8B9twoFRwWbFuF"};